/**
 * base3.xiaojukeji.com/docs/passport/开发指南/PC-passport接入.html
 * base3.xiaojukeji.com/docs/passport/概览/术语.html
 */

import qs from 'qs'
import config from '@/config/index'
import { getLocale } from './locale'
import UrlHandler from './urlHandler'
import UrlHashHandler from '@/utils/urlHashHandle'

const TYPES = {
  LOGIN: 'login',
  LOGOUT: 'logout',
}

class Passport {
  constructor({ passportUrl, setCookieUrl, appId, role, source, country_id, lang, theme }) {
    this.config = {
      passportUrl,
      setCookieUrl,
      appId,
      role,
      source,
      country_id,
      lang,
      theme,
    }
  }

  getHref(targetUrl) {
    const { passportUrl, appId, role, source, setCookieUrl, country_id, lang, theme } = this.config

    const currentHref = targetUrl

    const setCookieUrlQuery = qs.stringify({
      redirectUrl: encodeURI(decodeURI(currentHref)),
    })

    const passportUrlQuery = qs.stringify({
      appid: appId,
      role,
      source,
      country_id,
      redirectUrl: encodeURI(decodeURI(setCookieUrl + '?' + setCookieUrlQuery)),
      lang,
      theme,
    })

    return passportUrl + '?' + passportUrlQuery
  }

  get currentHref() {
    const urlHashHandler = new UrlHashHandler(location.href)
    urlHashHandler.set(TYPES.LOGIN)
    const loginHref = urlHashHandler.getUrl()
    return this.getHref(loginHref)
  }

  get loginHref() {
    const urlHashHandler = new UrlHashHandler(location.href)
    urlHashHandler.set(TYPES.LOGIN)
    const loginHref = urlHashHandler.getUrl()
    return this.getHref(loginHref)
  }

  get logoutHref() {
    const homeHref = this._homeHref
    const urlHashHandler = new UrlHashHandler(homeHref)
    urlHashHandler.set(TYPES.LOGOUT)
    const logoutHref = urlHashHandler.getUrl()
    return this.getHref(logoutHref)
  }

  get _homeHref() {
    const urlHandler = new UrlHandler(location.href)
    const targetPath = `${getLocale()}/food/address/`
    urlHandler.set({ pathname: targetPath })
    return urlHandler.getUrl()
  }

  login() {
    location.href = this.loginHref
  }

  logout() {
    location.href = this.logoutHref + '#/logout'
  }

  register() {
    location.href = this.currentHref + '#/register'
  }

  forget() {
    location.href = this.currentHref + '#/forget'
  }
}

export default new Passport(config.passport)
